<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24">ປະເມີນຄວາມເພິງພໍໃຈຂອງຜູ້ວາງສະແດງສິນຄ້າ (Booth)</span>
        </div>
          
      </div>
      <b-tabs v-model="activeTab" >

        <b-tab-item label="ຟອມປະເມີນ" style="">
            <div class="columns" >
              <div class="column">
                <div class="columns" >
                  <div class="column">
                    <b-field label="ຊື່ບູ໊ດ">
                      <b-input
                        v-model.trim="selectedBooth"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns" >
                  <div class="column">
                    <b-field label="ແຂວງ">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedProvince"
                        label="NAME"  
                        track-by="ID"
                        :options="provinceList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ສິນຄ້າຫຼັກຂອງບູ໊ດແມ່ນຫຍັງ">
                      <b-input
                        v-model.trim="selectedProductName"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns" >
                  <div class="column">
                    <b-field label="ຊື່ເຈົ້າຂອງ (Optional)">
                      <b-input
                        v-model.trim="selectedOwnerName"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ເບີໂທເຈົ້າຂອງ (Optional)">
                      <b-input
                        v-model.trim="selectedOwnerPhoneNo"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns" >
                  <div class="column">
                    <b-field label="ຊື່ຜູ້ຮັບຜິດຊອບ">
                      <b-input
                        v-model.trim="selectedStaffName"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ເບີໂທຜູ້ຮັບຜິດຊອບ">
                      <b-input
                        v-model.trim="selectedStaffPhoneNo"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                </div>

                <div class="columns" >
                  
                  <div class="column">
                    <b-field label="ຈຳນວນຜູ້ສົນໃຈບູ໋ດ (ສອບຖາມ + ທົດລອງສິນຄ້າ + ຊື້ສິນຄ້າ )">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedcustomerRank"
                        label="NAME"  
                        track-by="ID"
                        :options="customerRankList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ໄລຍະເວລາການຈັດງານ 5 ວັນ: ຫຼາຍເກີນໄປ ພໍດີ ໜ້ອຍເກີນໄປ">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedDuration" 
                        label="NAME"  
                        track-by="ID"
                        :options="durationList"       
                      ></Multiselect>
                    </b-field>
                  </div>
                </div>

             
                <div class="columns" >
                  <div class="column">
                    <b-field label="ໃຫ້ຄະແນນສະຖານທີ່ຈັດງານ: ຄະແນນ 1-10">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedPlaceScore"
                        label="NAME"  
                        track-by="ID"
                        :options="scoreList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ໃຫ້ຄະແນນກິດຈະກຳພາຍໃນງານ: ຄະແນນ 1-10">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedActivityScore"
                        label="NAME"  
                        track-by="ID"
                        :options="scoreList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                </div>

                <div class="columns" >
                  <div class="column">
                    <b-field label="ໃຫ້ຄະແນນການປະສານງານກັບຄະນະຈັດກງານ: ຄະແນນ 1-10">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedCorrdinationScore"
                        label="NAME"  
                        track-by="ID"
                        :options="scoreList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ງົບປະມານທີ່ໃຊ້ໃນການອອກບູດ: RANK">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedBudgetRank"
                        label="NAME"  
                        track-by="ID"
                        :options="budgetRankList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                </div>
                <div class="columns" >
                  <div class="column">
                    <b-field label="ປີໜ້າຈະເຂົ້າຮ່ວມງານ Agri Expo ອີກບໍ່">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedParticipateNextEvent"
                        label="NAME"  
                        track-by="ID"
                        :options="participateNextEventList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ງານ Agri Expo ປີໜ້າ ຄວນຈັດໃສ່ເດືອນໃດ">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedNextEventMonth"
                        label="NAME"  
                        track-by="ID"
                        :options="nextEventMonthList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                </div>

                <div class="columns" >
                  <div class="column">
                    <b-field label="ດີບໍ່ ຖ້າງານ Agri Expo ປີໜ້າ ຫັນເປັນ Digital ຫູາຍຂຶ້ນ ເຊັ່ນ: ລະບົບລະບຽນບູ໋ດ, ສະແກນ QR ເພື່ອເບິ່ງຂໍ້ມູນບູ໋ດ, ສັ່ງຊື້ສິນຄ້າໂດຍບໍ່ໄດ້ມາໜ້າບູ໋ດ ແລະ ອື່ນໆ">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedNextEventUptoDigital"
                        label="NAME"  
                        track-by="ID"
                        :options="nextEventUptoDigitalList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                </div>

                <div class="columns" >
                  <div class="column">
                    <b-field label="ໃຫ້ຄະແນນຄວາມເພິ່ງພໍໃຈຕໍ່ງານນີ້ໂດຍລວມ: ຄະແນນ 1-10">
                      <Multiselect     
                        placeholder=""
                        v-model.trim="selectedOrverallScore"
                        label="NAME"  
                        track-by="ID"
                        :options="scoreList"     
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="" style="margin-top: 30px;">
                      <b-button  v-if="isEditForm==1"
                          class="btn-group-margin is-fullwidth"
                          type="is-danger"  
                          @click="doEditEvent()"
                          >  <span > ແກ້ໄຂຂໍ້ມູນ</span>
                      </b-button>
                      <b-button v-else
                          class="btn-group-margin is-fullwidth"
                          type="is-success"  
                          @click="doSave()"
                          >  <span > ບັນທຶກ</span>
                      </b-button>
                    </b-field>
                  </div>
                </div>

                
                </div>
                
                
              <div class="column">
                
              </div>
              
                
            </div>

        </b-tab-item>
        
        <b-tab-item label="ລາຍງານ" >
          <table class="table is-fullwidth is-narrow is-small" >
            <thead>
              <tr>
                <th class="has-text-left " width="2%">
                  ລຳດັບ
                </th>
                <th class="has-text-left " width="40%">
                  ຊື່ Booth
                </th>
                <th class="has-text-left " width="20%">
                  ຜູ້ປ້ອນຂໍ້ມູນ
                </th>
                
                <th class="has-text-left " width="20%">
                  ລາຍລະອຽດ
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in eventBoothList"
                :key="data.ID"
              >
                <td class="has-text-left ">
                  {{ index +1 }}
                </td>
                <td class="has-text-left ">
                  {{ data.NAME }}
                </td> 
                <td class="has-text-left ">
                  {{ data.UPDATEBY }}
                </td> 
                
                <td class="has-text-centered ">
                  <b-button 
                      class="btn-group-margin is-fullwidth"
                      type="is-success"  
                      @click="detail(data)"
                      >  <span > ລາຍລະອຽດ</span>
                  </b-button>
                </td>  
                
              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ" >
          <div class="columns" >
              <div class="column">
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ຊື່ບູ໊ດ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataBooth }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ແຂວງ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataProvince }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ສິນຄ້າ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataProductName }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ຊື່ເຈົ້າຂອງ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataOwnerName }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ເບີໂທເຈົ້າຂອງ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataOwnerPhoneNo }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ຊື້ຜູ້ຮັບຜິດຊອບ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataStaffName }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ເບີໂທຜູ້ຮັບຜິດຊອບ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataStaffPhoneNo }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ຈຳນວນຜູ້ສົນໃຈບູ໋ດ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.datacustomerRank }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ໄລຍະເວລາການຈັດງານ 5 ວັນ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataDuration }}
                  </div>
                </div>
               
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ໃຫ້ຄະແນນສະຖານທີ່ຈັດງານ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataPlaceScore }} ຄະແນນ
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ໃຫ້ຄະແນນກິດຈະກຳພາຍໃນງານ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataActivityScore }} ຄະແນນ
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ໃຫ້ຄະແນນການປະສານງານກັບຄະນະຈັດກງານ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataCorrdinationScore }} ຄະແນນ
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ງົບປະມານທີ່ໃຊ້ໃນການອອກບູດ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataBudgetRank }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ປີໜ້າຈະເຂົ້າຮ່ວມງານ Agri Expo ອີກບໍ່:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataParticipateNextEvent }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ງານ Agri Expo ປີໜ້າ ຄວນຈັດໃສ່ເດືອນໃດ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     ເດືອນ {{ this.dataNextEventMonth }}  
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ດີບໍ່ ຖ້າງານ Agri Expo ປີໜ້າ ຫັນເປັນ Digital ຫູາຍຂຶ້ນ ເຊັ່ນ: ລະບົບລະບຽນບູ໋ດ, ສະແກນ QR ເພື່ອເບິ່ງຂໍ້ມູນບູ໋ດ, ສັ່ງຊື້ສິນຄ້າໂດຍບໍ່ໄດ້ມາໜ້າບູ໋ດ ແລະ ອື່ນໆ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataNextEventUptoDigital }}
                  </div>
                </div>
                <div class="columns" >
                  <div class="column first">
                    <b-field label="ໃຫ້ຄະແນນຄວາມເພິ່ງພໍໃຈຕໍ່ງານນີ້ໂດຍລວມ:">
                    
                    </b-field>
                  </div>
                  <div class="column second">
                     {{ this.dataOrverallScore }}
                  </div>
                </div>

              </div>
                
                
              <div class="column">
                
              </div>
              
                
            </div>
        </b-tab-item>

        <b-tab-item label="ລາຍງານສະຫຼຸບ" >
          <div class="columns" >
            <div class="column">

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ຄວາມເພິ່ງພໍໃຈໂດຍລວມ: <span style="color: red;">{{ overallscorereport[0].OVERALLSCORE }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="overallscoreDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button> 
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="overallscoreSwtich==1">
                 
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ຄະແນນ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ 
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in overallscorereport"
                            :key="data.OVERALLSCORE"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.OVERALLSCORE }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ແຂວງທີ່ເຂົ້າຮ່ວມຫຼາຍທີ່ສຸດ: <span style="color: red;">{{ provincereport[0].PROVINCENAME }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="provinceDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="provinceSwitch==1">
                      <canvas id="chartCanvas1"></canvas>
                 
                      <!-- <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ແຂວງ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຄະແນນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(province, index) in provincereport"
                            :key="province.PROVINCENAME"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ province.PROVINCENAME }}</td>
                            <td class="has-text-right ">{{ province.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table> -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ຈຳນວນຜູ້ສົນໃຈບູ໋ດ: <span style="color: red;">{{ numberofparticipatereport[0].CUSTOMERRANK }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="participateDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="participateSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ຈຳນວນຜູ້ສົນໃຈບູ໋ດ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(participaterank, index) in numberofparticipatereport"
                            :key="participaterank.CUSTOMERRANK"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ participaterank.CUSTOMERRANK }}</td>
                            <td class="has-text-right ">{{ participaterank.COUNTRANK }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ຈັດງານ 5 ວັນ: <span style="color: red;">{{ durationreport[0].DURATION }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="durationDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="durationSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ຈຳນວນວັນ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in durationreport"
                            :key="data.DURATION"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.DURATION }}</td>
                            <td class="has-text-right ">{{ data.COUNTDURATION }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ສະຖານທີ່ຈັດງານ: <span style="color: red;">{{ placescorereport[0].PLACESCORE }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="placescoreDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>  
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="placescoreSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ຄະແນນ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in placescorereport"
                            :key="data.PLACESCORE"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.PLACESCORE }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ກິດຈະກຳໃນງານ: <span style="color: red;">{{ activityscorereport[0].ACTIVITYSCORE }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="activityscoreDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>  
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="activityscoreSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ຄະແນນ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in activityscorereport"
                            :key="data.ACTIVITYSCORE"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.ACTIVITYSCORE }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ການປະສານງານກັບຄະນະຈັດງານ: <span style="color: red;">{{ coordinationscorereport[0].COORDINATIONSCORE }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="coordinationscoreDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>  
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="coordinationscoreSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ຄະແນນ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in coordinationscorereport"
                            :key="data.COORDINATIONSCORE"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.COORDINATIONSCORE }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ງົບປະມານທີ່ໃຊ້ໃນການອອກບູດ: <span style="color: red;">{{ budgetreport[0].BUDGET }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="budgetDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>  
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="budgetSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ງົບປະມານ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in budgetreport"
                            :key="data.BUDGET"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.BUDGET }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ປີໜ້າຈະເຂົ້າຮ່ວມງານ Agri Expo ອີກບໍ່? : <span style="color: red;">{{ nexteventreport[0].NEXTEVENT }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="nexteventDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>  
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="nexteventSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ການເຂົ້າຮ່ວມ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in nexteventreport"
                            :key="data.NEXTEVENT"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.NEXTEVENT }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ງານ Agri Expo ປີໜ້າ ຄວນຈັດໃສ່ເດືອນໃດ : <span style="color: red;">{{ nexteventmonthreport[0].NEXTEVENTMONTH }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="nexteventmonthDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>  
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="nexteventmonthSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ເດືອນ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in nexteventmonthreport"
                            :key="data.NEXTEVENTMONTH"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.NEXTEVENTMONTH }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
                <div class="column card-item" >
                  <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
                    <div class="card-content2 ">
                      <div style="margin-bottom: 5px;">
                        <b-field>ງານ Agri Expo ປີໜ້າ ຫັນເປັນ Digital ຫູາຍຂຶ້ນ: <span style="color: red;">{{ nexteventuptodigitalreport[0].NEXTEVENTUPTODIGITAL }}</span></b-field>
                      </div>
                      

                      <div style="margin-bottom: 5px;">
                        <b-button 
                            class="btn-group-margin"
                            type="is-success" 
                            @click="nexteventuptodigitalDetail()"
                            >  <span > ລາຍລະອຽດ</span>
                        </b-button>  
                      </div>
                    </div>
                    <div style="width: 50%;" v-if="nexteventuptodigitalSwitch==1">
                      <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" >
                        <thead>
                          <tr>
                            <th class="has-text-left " width="10%">
                              #
                            </th>
                            <th class="has-text-left " width="70%">
                              ຄວາມຕ້ອງການ
                            </th>
                            <th class="has-text-right " width="20%">
                              ຈຳນວນ
                            </th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr
                            v-for="(data, index) in nexteventuptodigitalreport"
                            :key="data.NEXTEVENTUPTODIGITAL"
                          > 
                            <td> {{ index +1 }}</td>
                            <td> {{ data.NEXTEVENTUPTODIGITAL }}</td>
                            <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
                          </tr>
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>
         
              
            </div>    
            <div class="column">

            </div>

          </div>
        </b-tab-item>
        
        
        
        
        
        
        
      </b-tabs>

      
      

      
    </div>


    

    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect },

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 3,

      selectedBooth: null,
      selectedProvince: null,
      provinceList:  [
        { ID: "1", NAME: "ນະຄອນຫຼວງວຽງຈັນ" },
        { ID: "2", NAME: "ຜົ້ງສາລີ" },
        { ID: "3", NAME: "ຫຼວງນໍ້າທາ" },
        { ID: "4", NAME: "ອຸດົມໄຊ" },
        { ID: "5", NAME: "ບໍ່ແກ້ວ" },
        { ID: "6", NAME: "ຫຼວງພຣະບາງ" },
        { ID: "7", NAME: "ຫົວພັນ" },
        { ID: "8", NAME: "ໄຊຍະບູລີ" },
        { ID: "9", NAME: "ໄຊສົມບູນ" },
        { ID: "10", NAME: "ຊຽງຂວາງ" },
        { ID: "11", NAME: "ວຽງຈັນ" },
        { ID: "12", NAME: "ບໍລິຄໍາໄຊ" },
        { ID: "13", NAME: "ຄໍາມ່ວນ" },
        { ID: "14", NAME: "ສະຫວັນນະເຂດ" },
        { ID: "15", NAME: "ສາລະວັນ" },
        { ID: "16", NAME: "ເຊກອງ" },
        { ID: "17", NAME: "ຈໍາປາສັກ" },
        { ID: "18", NAME: "ອັດຕະປື" }
      ],
      selectedProductName: null,
      selectedOwnerName: null,
      selectedOwnerPhoneNo: null,
      selectedStaffName: null,
      selectedStaffPhoneNo: null,
      selectedcustomerRank: null,
      customerRankList: [
        { ID: "1", NAME: "ຕ່ຳກວ່າ 50" },
        { ID: "2", NAME: "51-100" },
        { ID: "3", NAME: "101-200" },
        { ID: "4", NAME: "201-300" },
        { ID: "5", NAME: "ຫຼາຍກວ່າ 300" },
      ],
      selectedDuration: null,
      durationList:  [
        { ID: "1", NAME: "ໜ້ອຍໂພດ" },
        { ID: "2", NAME: "ພໍດີ" },
        { ID: "3", NAME: "ດົນໂພດ" }
      ],
      selectedPlaceScore: null,
      scoreList: [
      { ID: "10", NAME: "10" },
      { ID: "9", NAME: "9" },
      { ID: "8", NAME: "8" },
      { ID: "7", NAME: "7" },
      { ID: "6", NAME: "6" },
      { ID: "5", NAME: "5" },
      { ID: "4", NAME: "4" },
      { ID: "3", NAME: "3" },
      { ID: "2", NAME: "2" },
      { ID: "1", NAME: "1" },
      ],
      selectedActivityScore: null,
      selectedCorrdinationScore: null,
      selectedBudgetRank: null,
      budgetRankList: [
        { ID: "1", NAME: "ຕຳກວ່າ 3 ລ້ານ" },
        { ID: "2", NAME: "3 -5 ລ້ານ" },
        { ID: "3", NAME: "5 -10 ລ້ານ" },
        { ID: "4", NAME: "ຫຼກາຍວ່າ 10 ລ້ານ" },
      ],
      selectedParticipateNextEvent: null,
      participateNextEventList: [
        { ID: "1", NAME: "ບໍ່ເຂົ້າຮ່ວມ" },
        { ID: "2", NAME: "ບໍ່ທັນແນ່ໃຈ" },
        { ID: "3", NAME: "ເຂົ້າຮ່ວມແນ່ນອນ" }
      ],
      selectedNextEventMonth: null,
      nextEventMonthList: [
        { ID: "1", NAME: "1" },
        { ID: "2", NAME: "2" },
        { ID: "3", NAME: "3" },
        { ID: "4", NAME: "4" },
        { ID: "5", NAME: "5" },
        { ID: "6", NAME: "6" },
        { ID: "7", NAME: "7" },
        { ID: "8", NAME: "8" },
        { ID: "9", NAME: "9" },
        { ID: "10", NAME: "10" },
        { ID: "11", NAME: "11" },
        { ID: "12", NAME: "12" },
      ],
      selectedNextEventUptoDigital: null,
      nextEventUptoDigitalList: [
        { ID: "1", NAME: "ບໍ່ດີ" },
        { ID: "2", NAME: "ແນວໃດກະໄດ້" },
        { ID: "3", NAME: "ດີຫຼາຍ" }
      ],
      selectedOrverallScore: null,


      eventBoothList: [],

      dataBooth: null,
      dataProvince: null,
      dataProductName: null,
      dataOwnerName: null,
      dataOwnerPhoneNo: null,
      dataStaffName: null,
      dataStaffPhoneNo: null,
      datacustomerRank: null,
      dataDuration: null,
      dataPlaceScore: null,
      dataActivityScore: null,
      dataCorrdinationScore: null,
      dataBudgetRank: null,
      dataParticipateNextEvent: null,
      dataNextEventMonth: null,
      dataNextEventUptoDigital: null,
      dataOrverallScore: null,

      eventDisableList: [],

      selectedEventID: null,
      selectedEventName: null, 

      selectedEventISPAY: null,
      isPayList: [
        { ID: "0", NAME: "ເຂົ້າຟຣີ" },
        { ID: "1", NAME: "ເສຍເງິນ" },
      ],
      selectedStartDate: null,
      selectedEnddate: null,
      selectedStartTime: null,
      selectedEndTime: null,

      isEditForm: 0,

      provincereport : null,
      numberofparticipatereport : null,
      durationreport : null,
      placescorereport : null, 
      activityscorereport : null, 
      coordinationscorereport : null,
      budgetreport : null,
      nexteventreport : null, 
      nexteventmonthreport : null, 
      nexteventuptodigitalreport : null, 
      overallscorereport : null,

      provinceSwitch: 0,
      participateSwitch: 0,
      durationSwitch: 0,
      placescoreSwitch: 0,
      activityscoreSwitch: 0,  
      coordinationscoreSwitch: 0,
      budgetSwitch: 0,
      nexteventSwitch: 0,
      nexteventmonthSwitch: 0,
      nexteventuptodigitalSwitch : 0,
      overallscoreSwtich: 0,


      provincesdata: [],
      provincedatacount: [],


    };
     
    
  },
  methods: {   

    

    


    switchOff(){
      this.provinceSwitch = 0;
      this.participateSwitch= 0;
      this.durationSwitch= 0;
      this.placescoreSwitch= 0;
      this.activityscoreSwitch= 0;
      this.coordinationscoreSwitch= 0;
      this.budgetSwitch= 0;
      this.nexteventSwitch= 0;
      this.nexteventmonthSwitch= 0;
      this.nexteventuptodigitalSwitch= 0;
      this.overallscoreSwtich= 0;
    },

    overallscoreDetail(){
      this.switchOff();
      this.overallscoreSwtich = this.overallscoreSwtich == 1 ? 0 : 1 ;
    },

    provinceDetail(){
      this.switchOff();
      this.provinceSwitch = this.provinceSwitch == 1 ? 0 : 1 ;
    },
    participateDetail(){
      this.switchOff();
      this.participateSwitch = this.participateSwitch == 1 ? 0 : 1 ;
    },

    durationDetail(){
      this.switchOff();
      this.durationSwitch = this.durationSwitch == 1 ? 0 : 1 ;
    },

    placescoreDetail(){
      this.switchOff();
      this.placescoreSwitch = this.placescoreSwitch == 1 ? 0 : 1 ;
    },

    activityscoreDetail(){
      this.switchOff();
      this.activityscoreSwitch = this.activityscoreSwitch == 1 ? 0 : 1 ;
    },

    coordinationscoreDetail(){
      this.switchOff();
      this.coordinationscoreSwitch = this.coordinationscoreSwitch == 1 ? 0 : 1 ;
    },

    budgetDetail(){
      this.switchOff();
      this.budgetSwitch = this.budgetSwitch == 1 ? 0 : 1 ;
    },

    nexteventDetail(){
      this.switchOff();
      this.nexteventSwitch = this.nexteventSwitch == 1 ? 0 : 1 ;
    },

    nexteventmonthDetail(){
      this.switchOff();
      this.nexteventmonthSwitch = this.nexteventmonthSwitch == 1 ? 0 : 1 ;
    },

    nexteventuptodigitalDetail(){
      this.switchOff();
      this.nexteventuptodigitalSwitch = this.nexteventuptodigitalSwitch == 1 ? 0 : 1 ;
    },

    detail(data){
      this.dataBooth = data.NAME;
      this.dataProvince = data.PROVINCENAME;
      this.dataProductName = data.PRODUCTNAME;
      this.dataOwnerName = data.OWNERNAME;
      this.dataOwnerPhoneNo = data.OWNERPHONENO;
      this.dataStaffName = data.STAFFNAME;
      this.dataStaffPhoneNo = data.STAFFPHONENO;
      this.datacustomerRank = data.CUSTOMERRANK;
      this.dataDuration = data.DURATION;
      this.dataPlaceScore = data.PLACESCORE;
      this.dataActivityScore = data.ACTIVITYSCORE;
      this.dataCorrdinationScore = data.COORDINATIONSCORE;
      this.dataBudgetRank = data.BUDGET;
      this.dataParticipateNextEvent = data.NEXTEVENT;
      this.dataNextEventMonth = data.NEXTEVENTMONTH;
      this.dataNextEventUptoDigital = data.NEXTEVENTUPTODIGITAL;
      this.dataOrverallScore = data.OVERALLSCORE;
      this.activeTab = 2;
    },

    changeStatus(id, status){
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

    
            var params = {
              eventid: id,
              status: status,
              username: this.username,  
            };
            
            RestAPI.changeEventStatus(params) 
              .then(() => {

                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ລົງທະບຽນ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });                

                this.getEvent();
                this.activeTab = 0;

              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });
    },
    doSave(){
      if(!this.selectedBooth || this.selectedBooth === null || 
         !this.selectedProvince || this.selectedProvince === null || 
         !this.selectedProductName || this.selectedProductName === null || 
         !this.selectedStaffName || this.selectedStaffName === null || 
         !this.selectedStaffPhoneNo || this.selectedStaffPhoneNo === null || 
         !this.selectedcustomerRank || this.selectedcustomerRank === null || 
         !this.selectedDuration || this.selectedDuration === null || 
         !this.selectedPlaceScore || this.selectedPlaceScore === null || 
         !this.selectedActivityScore || this.selectedActivityScore === null || 
         !this.selectedCorrdinationScore || this.selectedCorrdinationScore === null || 
         !this.selectedBudgetRank || this.selectedBudgetRank === null || 
         !this.selectedParticipateNextEvent || this.selecteselectedParticipateNextEventdEventISPAY === null || 
         !this.selectedNextEventMonth || this.selectedNextEventMonth === null || 
         !this.selectedNextEventUptoDigital || this.selectedNextEventUptoDigital === null || 
         !this.selectedOrverallScore || this.selectedOrverallScore === null )     {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
              return false;
      }
    
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

    
            var params = {
  
              selectedBooth: this.selectedBooth,
              selectedProvince: this.selectedProvince.ID,
              selectedProductName: this.selectedProductName,
              selectedOwnerName: this.selectedOwnerName ? this.selectedOwnerName : '',
              selectedOwnerPhoneNo: this.selectedOwnerPhoneNo ?  this.selectedOwnerPhoneNo : '',
              selectedStaffName: this.selectedStaffName,
              selectedStaffPhoneNo: this.selectedStaffPhoneNo,
              selectedcustomerRank: this.selectedcustomerRank.ID,
              selectedDuration: this.selectedDuration.ID,
              selectedPlaceScore: this.selectedPlaceScore.ID,
              selectedActivityScore: this.selectedActivityScore.ID,
              selectedCorrdinationScore: this.selectedCorrdinationScore.ID,
              selectedBudgetRank: this.selectedBudgetRank.ID,
              selectedParticipateNextEvent: this.selectedParticipateNextEvent.ID,
              selectedNextEventMonth: this.selectedNextEventMonth.ID,
              selectedNextEventUptoDigital: this.selectedNextEventUptoDigital.ID,
              selectedOrverallScore: this.selectedOrverallScore.ID,
              username: this.username,  
            };
 
            // console.log("params: "+JSON.stringify(params))  
            
            RestAPI.doSaveBooth(params) 
              .then((res) => {

                if(res.data.responseData.data=== 'duplicate booth name'){
                    this.$swal("ຊື່ງບູ໊ດຊ້ຳ", "", "warning");
                    return false;
                }

                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ປະກອບແບບຟອມ ສຳຫຼວດ ສຳເລັດ!",
                    icon: "success",
                    timer: 5000,
                    showConfirmButton: false, 
                  });

                  this.selectedBooth = null;
                  this.selectedProvince = null; 
                  this.selectedProductName = null;
                  this.selectedStaffName = null; 
                  this.selectedStaffPhoneNo = null; 
                  this.selectedcustomerRank = null; 
                  this.selectedDuration = null; 
                  this.selectedPlaceScore = null; 
                  this.selectedActivityScore = null; 
                  this.selectedCorrdinationScore = null;
                  this.selectedBudgetRank = null; 
                  this.selectedParticipateNextEvent = null; 
                  this.selectedNextEventMonth = null; 
                  this.selectedNextEventUptoDigital = null; 
                  this.selectedOrverallScore = null; 

                  this.getEventBooth();
                  // this.activeTab = 0;

              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });
      
    },

    getEventBooth() {
      RestAPI.getEventBooth()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.eventBoothList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getEventBoothSummaryReport() {
      RestAPI.getEventBoothSummaryReport()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data)) 
          this.provincereport = res.data.responseData.data.province;
          this.provincedata = this.provincereport.map(item => item.PROVINCENAME);
          this.provincedatacount = this.provincereport.map(item => item.COUNTSCORE);

          this.numberofparticipatereport = res.data.responseData.data.numberofparticipate;
          this.durationreport = res.data.responseData.data.duration;
          this.placescorereport = res.data.responseData.data.placescore;
          this.activityscorereport = res.data.responseData.data.activityscore;
          this.coordinationscorereport = res.data.responseData.data.coordinationscore;
          this.budgetreport = res.data.responseData.data.budget;
          this.nexteventreport = res.data.responseData.data.nextevent;
          this.nexteventmonthreport = res.data.responseData.data.nexteventmonth;
          this.nexteventuptodigitalreport = res.data.responseData.data.nexteventuptodigital;
          this.overallscorereport = res.data.responseData.data.overallscore;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    this.username = this.user.USERNAME;   

    this.currentDate = new Date();

    this.selectedInterestingDate = new Date();  
    this.selectedWorstDate = new Date();  


    this.getEventBooth();
    this.getEventBoothSummaryReport();



    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrData)}`;
    },

    // computed: {

    //   filteredParticipateList() {
    //     return this.participateList.filter((data) =>
    //       data.FULLNAME.toLowerCase().includes(this.searchByFullName.toLowerCase())
    //     );
    //   },

    // },
  
   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card-container {
    margin: 0px;
  }

  .card-item {
    padding: 5px; /* Smaller spacing between cards */
  }

  .card {
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 6px; /* Slightly reduced border radius for compact look */
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for clean look */
    padding: 1px; /* 1px padding inside the card for a tight design */
    text-align: center;
    width: 100%;
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .card2 {
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 6px; /* Slightly reduced border radius for compact look */
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for clean look */
    padding: 1px; /* 1px padding inside the card for a tight design */
    width: 100%;
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .card:hover {
    transform: translateY(-3px);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
  }

  .card-content {
    font-size: 1em; /* Reduced font size */
    font-weight: bold;
    color: #333;
    padding: 10px 1px 10px 1px;
  }

  .card-content2 {
    font-size: 1em; /* Reduced font size */
    color: #333;
    padding: 10px 1px 10px 1px;
  }

.first{
  text-align: right;
  flex: 0 0 65%;
  
}
.second{
  flex: 0 0 35%;
}
.status-3 {
  background-color: #4FC3F7; /* Light blue for status 3 */
  color: white;
}

.status-2 {
  background-color: #B3E5FC; /* Lighter blue for status 2 */
  color: black;
}

.status-0 {
  background-color: #CFD8DC; /* Gray for status 0 */
  color: black;
}

.status-default {
  background-color: transparent; /* Default styling */
  color: inherit;
}

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
